import config from './config';
import HttpRequest from '../HttpRequest';

const axios = new HttpRequest(config);
export default axios;
